import { Form } from 'react-bootstrap';
import { Option, Question, Section } from '../../../../response/test.response';
import { useApp } from '../../../../hook/app.hook';
import { CustomTextView } from '../../../../view/custom-text.view';
import { useId } from 'react';
import { getLanguageContent } from '../../../../util/language.util';
import { QuestionFormat } from '../../../../enum/question-format';

const MultipleChoiceComponent = () => {
  const id = useId();
  const { testRes, saveQuestionResponse, language } = useApp();

  const question = testRes.sectionList
    .filter((section: Section) => section.active)[0]
    .questionList.filter((question: Question, index: number) => {
      return question.active;
    })[0];

  return (
    <div>
      {question.optionList?.map((option: Option) => {
        return (
          <Form.Check
            type="checkbox"
            id={`question_${question.id}_${option.id}_${id}`}
            label={
              <CustomTextView
                initData={getLanguageContent(option.value, language)}
                format={
                  question.format.length > 0
                    ? question.format
                    : QuestionFormat.RICH_HTML
                }
              />
            }
            name="mcq"
            value={option.id}
            defaultChecked={option.selected}
            checked={option.selected}
            className="mb-3 bg-white d-flex align-items-center p-0 mcq-inputs border border-levenderblue rounded w-100"
            onChange={(e: any) => {
              const newValue = e.target.value;
              const optionIdList = question.optionList
                .filter((option: Option) => {
                  return (
                    (option.id == newValue && !option.selected) ||
                    (option.id != newValue && option.selected)
                  );
                })
                .map((option: Option) => {
                  return option.id;
                });
              saveQuestionResponse(question.id, null, optionIdList);
            }}
          />
        );
      })}
    </div>
  );
};

export default MultipleChoiceComponent;
